<template>
  <div style="">
    <el-card shadow="never" style="padding-bottom: 15px">
      <el-col :xs="12" :sm="12" :md="12" :lg="3" style="padding-top: 5pt">
        <span class="head-title">Payroll Settings</span>
      </el-col>
    </el-card>
    <el-card class="box-card">
      <el-tabs :tab-position="tabPosition" v-model="activeTabName" @tab-click="setActiveTabName(activeTabName)">
        <el-tab-pane v-for="tab in tabs" :label="tab.displayName" :name="tab.name" :key="tab.id">
          <div v-if="( tab.name === activeTabName)" >
            <component :is="tab.component_name" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import Deduction from './Deduction'
import Agency from './Agency'
import Benefits from './Benefits'
import Functions from './Functions'
// import PBB from './PBB'
import TaxTable from './TaxTable'
import LessPay from './LessPay'
import DefaultBeneFits from './DefaultBeneFits'
import Signatory from './Signatory'
import CasualDays from './Casual_days'
export default {
  name: 'PayRollSetting',
  components: {
    Deduction,
    Agency
  },
  data() {
    return {
      tabPosition: 'left',
      tabs: [
        {
          name: 'Deduction',
          displayName: 'Deduction',
          component_name: Deduction
        },
        {
          name: 'Agency',
          displayName: 'Agency',
          component_name: Agency
        },
        {
          name: 'Benefits',
          displayName: 'Benefits',
          component_name: Benefits
        },
        {
          name: 'Functions',
          displayName: 'Functions',
          component_name: Functions
        },
        // {
        //   name: 'PBB',
        //   displayName: 'PBB',
        //   component_name: PBB
        // },
        {
          name: 'TaxTable',
          displayName: 'TaxTable',
          component_name: TaxTable
        },
        {
          name: 'LessPay',
          displayName: 'LessPay',
          component_name: LessPay
        },
        {
          name: 'DefaultBeneFits',
          displayName: 'DefaultBeneFits',
          component_name: DefaultBeneFits
        },
        {
          name: 'Signatory',
          displayName: 'Signatory',
          component_name: Signatory
        },
        {
          name: 'CasualDays',
          displayName: 'Casual # of Days',
          component_name: CasualDays
        }
      ],
      activeTabName: null
    }
  },
  created: function() {
    this.activeTabName = this.tabs[0].name
  },
  methods: {
    setActiveTabName(name) {
      this.activeTabName = name
    }
  }
}
</script>

